{
  "title": "موافقاتي",
  "status": {
    "IN_PROGRESS": "بانتظار الاعتماد",
    "BLOCKED": "متوقف",
    "ACTION_PENDING": "قيد الإنهاء",
    "ACTION_FAILED": "فشل الإجراء",
    "APPROVED": "معتمد",
    "REJECTED": "مرفوض",
    "RETURNED": "مُعاد للتعديل",
    "CANCELLED": "ملغى",
    "SUPERSEDED": "مُستبدل"
  },
  "subject": {
    "purchase": "مشتريات",
    "project_budget": "موازنة مشروع",
    "project_variation": "أمر تغييري",
    "project_claim": "مستخلص",
    "service_contract": "عقد صيانة"
  },
  "tabs": {
    "label": "عروض الموافقات",
    "waiting": "بانتظاري",
    "submitted": "قدّمتها أنا",
    "completed": "المنجزة",
    "delegations": "التفويضات"
  },
  "inbox": {
    "intro": "المستندات التي تنتظر قرارك، والطلبات التي أرسلتها.",
    "document": "المستند",
    "requester": "مقدم الطلب",
    "step": "المرحلة",
    "due": "الاستحقاق",
    "amount": "المبلغ",
    "waitingSince": "بانتظار منذ",
    "workflow": "مسار الاعتماد",
    "submittedAt": "تاريخ التقديم",
    "decision": "قرارك",
    "decidedAt": "تاريخ القرار",
    "outcome": "الطلب",
    "stepOf": "المرحلة {{index}} من {{total}}",
    "stepOfNamed": "المرحلة {{index}} من {{total}} · {{name}}",
    "onBehalfOf": "نيابةً عن {{name}}",
    "overdue": "متأخر",
    "overdueSince": "متأخر منذ {{date}}",
    "dueOn": "يستحق في {{date}}",
    "noDueDate": "بلا موعد استحقاق",
    "finished": "انتهى",
    "tableWaiting": "الموافقات التي تنتظرني",
    "tableSubmitted": "الطلبات التي قدّمتها",
    "tableCompleted": "الموافقات التي بتُّ فيها",
    "overdueCount": "{{n}} متأخرة",
    "empty": {
      "waiting": "لا شيء بانتظارك",
      "waitingBody": "عندما يحتاج مستند إلى موافقتك يظهر هنا، والأكثر إلحاحًا أولًا.",
      "submitted": "لم تقدّم أي مستند للاعتماد",
      "submittedBody": "تظهر هنا المستندات التي ترسلها للاعتماد وأين وصل كل منها.",
      "completed": "لا قرارات بعد",
      "completedBody": "تُحفظ هنا الموافقات التي اعتمدتها أو أعدتها أو رفضتها."
    },
    "overdueBy": "متأخر {{duration}}",
    "dueSoon": "يستحق {{when}}",
    "summary": {
      "label": "نظرة سريعة",
      "toDecide": "بانتظار قرارك",
      "noneOverdue": "لا شيء متأخر",
      "allClear": "لا شيء ينتظرك",
      "open": "طلباتي المفتوحة",
      "openDetail": "قيد الاعتماد",
      "decided": "قراراتي",
      "decidedDetail": "الإجمالي",
      "delegations": "التفويضات",
      "delegationsDetail": "نافذة الآن"
    },
    "stepShort": "{{index}} من {{total}}"
  },
  "decision": {
    "APPROVED": "اعتمدتُ",
    "REJECTED": "رفضتُ",
    "RETURNED": "أعدتُ للتعديل"
  },
  "request": {
    "back": "موافقاتي",
    "submittedBy": "قدّمه {{name}} {{when}}",
    "submittedByAt": "قدّمه {{name}}",
    "progress": "سير الاعتماد",
    "notFound": "هذا الطلب غير متاح",
    "notFoundBody": "ربما سُحب، أو أنك لست من المشاركين فيه.",
    "stepMeter": "المرحلة {{index}} من {{total}}",
    "withdraw": "سحب الطلب",
    "withdrawTitle": "هل تريد سحب هذا الطلب؟",
    "withdrawBody": "تُغلق مهام المعتمدين ويصبح المستند قابلًا للتعديل من جديد. يمكنك تقديمه مرة أخرى لاحقًا.",
    "withdrawn": "سُحب الطلب",
    "blocked": {
      "NO_ELIGIBLE_APPROVER": "لا أحد يستطيع اعتماد هذه المرحلة الآن. على مدير النظام إعادة إسنادها أو تعديل مسار الاعتماد.",
      "NO_STEP_APPLIES": "لا تنطبق أي مرحلة اعتماد على هذا المستند. على مدير النظام تعديل مسار الاعتماد."
    },
    "actionFailed": "اعتُمد الطلب لكن الإجراء بعد الاعتماد فشل. يمكن لمدير النظام إعادة المحاولة.",
    "actionPending": "اعتُمد الطلب، والإجراء بعد الاعتماد قيد التنفيذ.",
    "previous": "طلب سابق",
    "next": "طلب لاحق",
    "subjectOff": {
      "purchase": "المشتريات معطّلة لشركتك، لذا فإن هذا الطلب معلّق: لا يمكن لأحد اعتماده أو رفضه أو سحبه أو معالجته حتى يُعاد تفعيل المشتريات.",
      "project_budget": "المشاريع معطّلة لشركتك، لذا فإن هذا الطلب معلّق: لا يمكن لأحد اعتماده أو رفضه أو سحبه أو معالجته حتى يُعاد تفعيل المشاريع.",
      "project_variation": "المشاريع معطّلة لشركتك، لذا فإن هذا الطلب معلّق: لا يمكن لأحد اعتماده أو رفضه أو سحبه أو معالجته حتى يُعاد تفعيل المشاريع.",
      "project_claim": "المشاريع معطّلة لشركتك، لذا فإن هذا الطلب معلّق: لا يمكن لأحد اعتماده أو رفضه أو سحبه أو معالجته حتى يُعاد تفعيل المشاريع.",
      "service_contract": "عقود الصيانة معطّلة لشركتك، لذا فإن هذا الطلب معلّق: لا يمكن لأحد اعتماده أو رفضه أو سحبه أو معالجته حتى يُعاد تفعيلها."
    }
  },
  "document": {
    "title": "المستند",
    "party": "المورد",
    "customer": "العميل",
    "reference": "المرجع",
    "amount": "المبلغ",
    "lines": "البنود",
    "description": "الوصف",
    "quantity": "الكمية",
    "lineAmount": "المبلغ",
    "open": "فتح فاتورة الشراء",
    "changed": "تغيّر هذا المستند بعد تقديمه.",
    "changedBody": "ما تراه هو المستند بحالته الحالية. القرارات ما زالت تخص هذا الطلب.",
    "noLines": "لا بنود",
    "openBudget": "فتح الموازنة",
    "budgetReason": "سبب هذا الإصدار",
    "budgetChange": "التغيير عن الموازنة المعتمدة",
    "budgetFirst": "أول موازنة: كامل تكلفتها",
    "budgetIncrease": "(زيادة)",
    "hidden": "لا تملك صلاحية الاطلاع على تفاصيل هذا المستند.",
    "openVariation": "فتح الأمر التغييري",
    "openClaim": "فتح المستخلص",
    "amountVariation": "قيمة الأمر التغييري (قبل الضريبة)",
    "amountClaim": "صافي المطالبة (قبل الضريبة)",
    "openContract": "فتح العقد",
    "amountContract": "قيمة العقد (قبل الضريبة)",
    "contractPeriod": "المدة",
    "contractSites": "المواقع",
    "contractAssets": "المعدات المشمولة",
    "contractRenews": "يجدّد"
  },
  "steps": {
    "title": "المراحل",
    "any": "يكفي اعتماد أيٍّ من هؤلاء",
    "all": "يجب أن يعتمد الجميع",
    "waitingFor": "بانتظار",
    "startsLater": "تبدأ بعد اعتماد المرحلة التي قبلها",
    "skipped": "تم تخطيها: شرطها لا ينطبق على هذا المستند",
    "noApprovers": "لم يُسند إليها أحد",
    "dueOn": "تستحق في {{date}}",
    "decidedBy": "بواسطة {{name}}",
    "onBehalfOf": "{{name}} نيابةً عن {{assignee}}",
    "notEligible": "لا يمكنه البت الآن",
    "status": {
      "PENDING": "لم تبدأ",
      "ACTIVE": "جارية",
      "APPROVED": "معتمدة",
      "SKIPPED": "متخطاة",
      "REJECTED": "مرفوضة",
      "RETURNED": "مُعادة",
      "CANCELLED": "ملغاة"
    },
    "task": {
      "PENDING": "بانتظار القرار",
      "APPROVED": "اعتمد",
      "REJECTED": "رفض",
      "RETURNED": "أعاد للتعديل",
      "CLOSED": "لم يعد مطلوبًا",
      "REASSIGNED": "أُعيد إسناده"
    },
    "progress": "{{done}} من {{total}} مكتملة"
  },
  "timeline": {
    "title": "السجل",
    "system": "سحاب",
    "empty": "لم يحدث شيء بعد.",
    "onBehalfOf": "نيابةً عن {{name}}",
    "event": {
      "SUBMITTED": "قدّمه {{actor}} للاعتماد",
      "STEP_ACTIVATED": "بدأت مرحلة «{{step}}»",
      "STEP_SKIPPED": "تم تخطي مرحلة «{{step}}» لأن شرطها لا ينطبق",
      "STEP_COMPLETED": "اعتُمدت مرحلة «{{step}}»",
      "TASK_APPROVED": "اعتمده {{actor}}",
      "TASK_REJECTED": "رفضه {{actor}}",
      "TASK_RETURNED": "أعاده {{actor}} للتعديل",
      "BLOCKED": "توقف: لا أحد يستطيع اعتماد «{{step}}»",
      "APPROVERS_REFRESHED": "حدّث {{actor}} قائمة المعتمدين",
      "REASSIGNED": "أعاد {{actor}} إسناد مهمة",
      "REMINDER_DUE": "أُرسل تذكير إلى المعتمدين",
      "OVERDUE": "تجاوزت مرحلة «{{step}}» موعد استحقاقها",
      "APPROVED": "اعتُمدت جميع المراحل",
      "ACTION_QUEUED": "أُدرج الإجراء بعد الاعتماد في قائمة التنفيذ",
      "ACTION_SUCCEEDED": "اكتمل الإجراء بعد الاعتماد",
      "ACTION_FAILED": "فشل الإجراء بعد الاعتماد",
      "ACTION_RETRIED": "أعاد {{actor}} محاولة الإجراء بعد الاعتماد",
      "DOCUMENT_ACTED": "أتمّ {{actor}} المستند",
      "CANCELLED": "ألغى {{actor}} الطلب",
      "WITHDRAWN": "سحب {{actor}} الطلب",
      "SUPERSEDED": "استُبدل: تغيّر المستند بعد تقديمه"
    },
    "anyStep": "مرحلة"
  },
  "decide": {
    "title": "قرارك",
    "hint": "مطلوب منك اعتماد {{subject}} في مرحلة «{{step}}».",
    "hintDelegated": "تبتّ نيابةً عن {{name}} في مرحلة «{{step}}».",
    "notEligible": "قد يرفض النظام قرارك: لم تعد مؤهلًا لهذه المرحلة.",
    "approve": "اعتماد",
    "return": "إعادة للتعديل",
    "reject": "رفض",
    "approveTitle": "هل تريد اعتماد هذا الطلب؟",
    "approveBody": "يُسجَّل اعتمادك باسمك. إن كانت هذه آخر مرحلة ينتقل المستند إلى ما بعدها.",
    "returnTitle": "إعادة للتعديل",
    "returnBody": "يستطيع مقدم الطلب تعديل المستند وتقديمه مرة أخرى.",
    "rejectTitle": "رفض هذا الطلب",
    "rejectBody": "يتوقف الطلب هنا ويرى مقدم الطلب سببك. لا يمكن تقديم المشتريات مرة أخرى دون تعديل؛ فإن كان تعديلٌ ما يجعلها مقبولة فأعدها للتعديل بدلًا من ذلك.",
    "comment": "تعليق",
    "commentOptional": "تعليق (اختياري)",
    "reason": "السبب",
    "reasonHint": "3 أحرف على الأقل. يراه مقدم الطلب.",
    "reasonRequired": "اكتب سببًا من 3 أحرف على الأقل",
    "approved": "تم الاعتماد",
    "returned": "أُعيد للتعديل",
    "rejected": "تم الرفض",
    "lastStepPost": "هذه آخر مرحلة: ستُرحَّل المشتريات (استلام البضاعة وتسجيل الفاتورة).",
    "lastStepApprove": "هذه آخر مرحلة: ستُعتمد المشتريات وتصبح جاهزة للترحيل.",
    "lastStepBudget": "هذه آخر مرحلة: ستُعتمد الموازنة وتصبح الموازنة الأساسية للمشروع.",
    "returnInstead": "الإعادة للتعديل بدلًا من ذلك",
    "lastStepVariation": "هذه الخطوة الأخيرة: سيُقدَّم الأمر التغييري إلى العميل.",
    "lastStepClaim": "هذه الخطوة الأخيرة: سيُرقَّم المستخلص ويُقدَّم إلى العميل.",
    "lastStepContract": "هذه هي الخطوة الأخيرة: سيُفعَّل العقد، فيبدأ تغطية الأوامر وتُنشئ خططه الزيارات الوقائية."
  },
  "errors": {
    "TASK_CLOSED": "هذه المهمة مغلقة: بتّ فيها شخص آخر أو انتقل الطلب إلى مرحلة أخرى.",
    "RUN_NOT_ACTIVE": "لم يعد هذا الطلب بانتظار قرار.",
    "NOT_ELIGIBLE": "لم يعد بإمكانك البت في هذه المرحلة (تغيّرت صلاحياتك أو دورك).",
    "SELF_APPROVAL": "لا يمكنك اعتماد مستند قدّمته بنفسك.",
    "ALREADY_DECIDED_IN_STEP": "سبق أن بتَّ في مرحلة سابقة من هذا الطلب.",
    "NOT_FOUND": "هذه المهمة ليست لك أو لم تعد موجودة.",
    "APPROVAL_PENDING": "المستند بانتظار الاعتماد ولا يمكن تغييره الآن.",
    "APPROVAL_ON_HOLD": "مسارات الاعتماد معطّلة لشركتك، لذا فإن طلب اعتماد هذا المستند معلّق. ويبقى المستند مقفلًا حتى يُعاد تفعيلها.",
    "APPROVAL_REQUIRED": "يجب اعتماد هذا المستند قبل ترحيله.",
    "APPROVAL_STALE": "تغيّر المستند بعد اعتماده. قدّمه للاعتماد مرة أخرى.",
    "APPROVAL_REJECTED_UNCHANGED": "عدّل المستند قبل تقديمه مرة أخرى، فقد رُفض بحالته هذه.",
    "NO_APPROVAL_NEEDED": "لا ينطبق أي مسار اعتماد على هذا المستند. يمكنك ترحيله.",
    "DELEGATION_INVALID": "لا يمكن إنشاء هذا التفويض. تحقق من الشخص ومن التواريخ.",
    "VERSION_CONFLICT": "غيّر شخص آخر هذا في الأثناء. أعد التحميل وحاول مرة أخرى.",
    "WORKFLOW_INVALID": "لا يستطيع مسار الاعتماد تنفيذ ذلك بإعداده الحالي. راجع مراحله ثم حاول مرة أخرى.",
    "IMPERSONATION_RESTRICTED": "أنت مسجّل الدخول بصفة هذا المستخدم من وحدة تحكم المنصة. تبقى قرارات الاعتماد والتفويضات الخاصة به من شأنه وحده."
  },
  "delegations": {
    "intro": "اسمح لزميل بالبت في موافقاتك أثناء غيابك.",
    "new": "تفويض موافقاتي",
    "table": "تفويضاتي",
    "direction": "التفويض",
    "to": "إلى {{name}}",
    "from": "من {{name}}",
    "period": "المدة",
    "periodValue": "{{from}} – {{to}}",
    "documents": "المستندات",
    "allDocuments": "كل أنواع المستندات",
    "reason": "السبب",
    "state": "الحالة",
    "stateLabel": {
      "current": "نافذ",
      "upcoming": "قادم",
      "past": "منتهٍ",
      "revoked": "مُلغى"
    },
    "revoke": "إلغاء التفويض",
    "revokeTitle": "هل تريد إلغاء هذا التفويض؟",
    "revokeBody": "لن يتمكن {{name}} من البت في موافقاتك بعد الآن. القرارات السابقة تبقى كما هي.",
    "revoked": "أُلغي التفويض",
    "rowActions": "إجراءات التفويض إلى {{name}}",
    "empty": "لا توجد تفويضات",
    "emptyBody": "ستأخذ إجازة؟ فوّض موافقاتك إلى زميل طوال مدة غيابك.",
    "form": {
      "title": "تفويض موافقاتي",
      "description": "يستطيع الشخص الذي تختاره الاعتماد أو الإعادة أو الرفض بدلًا منك بين هذين التاريخين، وتبقى صلاحياتك كما هي.",
      "delegate": "التفويض إلى",
      "delegatePlaceholder": "اختر زميلًا",
      "noDelegates": "لا يوجد زميل يمكنه تولي موافقاتك.",
      "startsAt": "من",
      "endsAt": "حتى",
      "subject": "المستندات",
      "reason": "السبب",
      "reasonPlaceholder": "مثال: إجازة سنوية",
      "save": "تفويض",
      "created": "فُوّضت موافقاتك إلى {{name}}",
      "chooseDelegate": "اختر من يبتّ بدلًا منك",
      "chooseStart": "اختر وقت البدء",
      "chooseEnd": "اختر وقت الانتهاء",
      "endAfterStart": "يجب أن يكون الانتهاء بعد البدء",
      "from": "تفويض موافقات",
      "fromPlaceholder": "اختر شخصًا",
      "chooseFrom": "اختر صاحب الموافقات المفوَّضة",
      "samePerson": "اختر شخصين مختلفين"
    },
    "revokeNamed": "إلغاء التفويض إلى {{name}}",
    "newShort": "تفويض"
  },
  "panel": {
    "label": "الاعتماد",
    "needed": "تحتاج هذه المشتريات إلى اعتماد قبل ترحيلها.",
    "neededWorkflow": "مسار الاعتماد: {{name}}",
    "waiting": "بانتظار «{{step}}» · المرحلة {{index}} من {{total}}",
    "waitingShort": "بانتظار الاعتماد",
    "submittedBy": "قدّمها {{name}} في {{date}}",
    "blocked": "الاعتماد متوقف: لا أحد يستطيع اعتماد «{{step}}».",
    "blockedBody": "على مدير النظام إعادة إسناد المرحلة أو تعديل مسار الاعتماد.",
    "noStep": "الاعتماد متوقف: لا تنطبق أي مرحلة اعتماد.",
    "actionPending": "اعتُمدت؛ جارٍ الترحيل…",
    "actionFailed": "اعتُمدت، لكن الترحيل فشل.",
    "actionFailedBody": "يمكن لمدير النظام إعادة المحاولة من شاشة متابعة الاعتمادات.",
    "approved": "معتمدة — جاهزة للترحيل",
    "approvedBody": "اعتُمدت في {{date}}.",
    "rejected": "مرفوضة",
    "returned": "أُعيدت للتعديل",
    "reason": "السبب: {{reason}}",
    "editResubmit": "عدّل المشتريات عند الحاجة ثم قدّمها للاعتماد مرة أخرى.",
    "stale": "تغيّرت المشتريات بعد اعتمادها. قدّمها للاعتماد مرة أخرى.",
    "cancelled": "سُحب طلب الاعتماد. قدّمها مرة أخرى عندما تكون جاهزة.",
    "viewRequest": "عرض الطلب",
    "review": "مراجعة واتخاذ القرار",
    "withdraw": "سحب",
    "locked": "التعديل والترحيل مقفلان ما دام الطلب مفتوحًا.",
    "submit": "تقديم للاعتماد",
    "resubmit": "تقديم مرة أخرى",
    "submitted": "قُدّمت للاعتماد",
    "noLongerNeeded": "لم يعد الاعتماد مطلوبًا. يمكنك ترحيلها.",
    "onHoldStamp": "معلّق",
    "onHold": "معلّق: مسارات الاعتماد معطّلة لشركتك.",
    "onHoldBody": "هذا الطلب مجمّد: لا يمكن لأحد اعتماده أو رفضه أو سحبه. وتبقى المشتريات مقفلة — فلا يمكن تعديلها أو ترحيلها أو حذفها — حتى يُعاد تفعيل مسارات الاعتماد. اطلب من مسؤول النظام إعادة تفعيلها.",
    "off": "مسارات الاعتماد معطّلة لشركتك: تُرحَّل هذه المشتريات مباشرة.",
    "offRejected": "رُفضت هذه النسخة. غيّر المشتريات قبل ترحيلها."
  },
  "nav": {
    "badge": "{{n}} بالانتظار",
    "badgeOverdue": "{{n}} بالانتظار، منها {{overdue}} متأخرة"
  },
  "monitor": {
    "title": "طلبات الاعتماد",
    "intro": "كل طلبات الاعتماد في الشركة: اعثر على المتوقف منها وحرّكه.",
    "back": "طلبات الاعتماد",
    "table": "طلبات الاعتماد",
    "views": {
      "label": "عروض الطلبات",
      "attention": "تحتاج انتباهًا",
      "active": "مفتوحة",
      "closed": "منتهية",
      "all": "الكل"
    },
    "filters": {
      "status": "الحالة",
      "allStatuses": "كل الحالات",
      "subject": "نوع المستند",
      "allSubjects": "كل أنواع المستندات",
      "search": "البحث في الطلبات",
      "searchPlaceholder": "ابحث بالمستند…",
      "workflow": "مسار الاعتماد: {{name}}",
      "workflowUnknown": "مسار اعتماد واحد",
      "clearWorkflow": "عرض كل المسارات",
      "clear": "مسح عوامل التصفية"
    },
    "columns": {
      "document": "المستند",
      "amount": "المبلغ",
      "workflow": "مسار الاعتماد",
      "status": "الحالة",
      "step": "المرحلة",
      "waiting": "مدة الانتظار",
      "lastEvent": "آخر حدث",
      "requester": "مقدم الطلب",
      "submitted": "تاريخ التقديم"
    },
    "workflowVersion": "{{name}} · الإصدار {{version}}",
    "overdue": "متأخر",
    "empty": {
      "attention": "لا شيء يحتاج انتباهًا",
      "attentionBody": "لا يوجد طلب متوقف أو فاشل أو متأخر.",
      "other": "لا توجد طلبات",
      "otherBody": "لا يوجد طلب اعتماد يطابق عوامل التصفية هذه."
    },
    "explain": {
      "blocked": "متوقف: لا يوجد معتمد مؤهل لمرحلة «{{step}}».",
      "blockedNoStep": "متوقف: لا تنطبق أي مرحلة اعتماد على هذا المستند.",
      "blockedHint": "أعد إسناد المرحلة إلى من يستطيع اعتمادها، أو صحّح الأدوار ثم حدّث المعتمدين.",
      "excludedTitle": "المستبعدون عند بدء المرحلة",
      "missing": "مستخدمون أو أدوار في المسار لم تعد موجودة: {{n}}",
      "failed": "سُجّل الاعتماد النهائي، لكن الإجراء بعد الاعتماد فشل.",
      "failedHint": "عالج السبب ثم أعد محاولة الإجراء بعد الاعتماد.",
      "attempts": "عدد المحاولات حتى الآن: {{n}}",
      "overdue": "مرحلة «{{step}}» متأخرة منذ {{date}}.",
      "details": "التفاصيل: {{message}}",
      "missingUser": "مستخدم لم يعد موجودًا ({{id}})",
      "missingRole": "دور لم يعد موجودًا ({{id}})",
      "missingTitle": "مذكورون في مسار الاعتماد لكنهم لم يعودوا موجودين"
    },
    "exclusion": {
      "REQUESTER": "هو مقدم الطلب",
      "USER_INACTIVE": "مستخدم غير نشط",
      "MISSING_PERMISSION": "لا يملك صلاحية اعتماد المشتريات",
      "PRIOR_APPROVER": "اعتمد مرحلة سابقة",
      "NOT_ASSIGNED": "غير مُسند إلى هذه المرحلة",
      "YOURSELF": "هو أنت",
      "DELEGATES_TO_YOU": "فوّض إليك اعتماداته",
      "ALREADY_IN_STEP": "يعتمد هذه المرحلة بالفعل",
      "SUBJECT_MODULE_OFF": "المشتريات معطّلة لشركتك"
    },
    "eligibleNow": "يمكنه البت الآن",
    "notEligibleNow": "لا يمكنه البت الآن: {{reason}}",
    "actions": {
      "reassign": "إعادة إسناد",
      "refresh": "تحديث المعتمدين",
      "retry": "إعادة محاولة الإجراء بعد الاعتماد",
      "cancel": "إلغاء الطلب",
      "more": "إجراءات أخرى"
    },
    "reassign": {
      "title": "إعادة إسناد الاعتماد",
      "body": "يحصل الشخص الذي تختاره على المهمة الآن، ولا يعود بإمكان من سُحبت منه البت فيها.",
      "task": "المهمة",
      "taskOf": "مهمة {{name}}",
      "addApprover": "إضافة معتمد إلى «{{step}}»",
      "to": "الإسناد إلى",
      "toPlaceholder": "اختر شخصًا",
      "reason": "السبب",
      "reasonHint": "3 أحرف على الأقل. يُحفظ في السجل.",
      "confirm": "إعادة إسناد",
      "done": "أُعيد الإسناد إلى {{name}}",
      "chooseTask": "اختر المهمة المراد إعادة إسنادها",
      "choosePerson": "اختر من يتولاها",
      "noCandidates": "لا يوجد من يمكنه تولي هذه المهمة."
    },
    "refresh": {
      "title": "هل تريد تحديث المعتمدين؟",
      "body": "يحدد سحاب من جديد من يعتمد «{{step}}» وفق مسار الاعتماد: من أصبح مؤهلًا يحصل على مهمة، ومن لم يعد مؤهلًا تُسحب منه مهمته.",
      "confirm": "تحديث المعتمدين",
      "done": "حُدّث المعتمدون"
    },
    "retry": {
      "title": "هل تريد إعادة محاولة الإجراء بعد الاعتماد؟",
      "body": "يُنفَّذ الإجراء بعد الاعتماد (ترحيل المشتريات) مرة أخرى الآن. إن لم يُعالج سببه فسيفشل مجددًا.",
      "confirm": "إعادة المحاولة",
      "done": "أُعيدت محاولة الإجراء بعد الاعتماد"
    },
    "cancel": {
      "title": "هل تريد إلغاء هذا الطلب؟",
      "body": "تُغلق مهام المعتمدين ويُفتح المستند للتعديل، وعلى مقدم الطلب تقديمه مرة أخرى.",
      "reason": "السبب",
      "confirm": "إلغاء الطلب",
      "keep": "إبقاء الطلب",
      "done": "أُلغي الطلب"
    },
    "eventShort": {
      "SUBMITTED": "قُدّم",
      "STEP_ACTIVATED": "بدأت مرحلة",
      "STEP_SKIPPED": "تُخطيت مرحلة",
      "STEP_COMPLETED": "اعتُمدت مرحلة",
      "TASK_APPROVED": "اعتمده شخص",
      "TASK_REJECTED": "رُفض",
      "TASK_RETURNED": "أُعيد للتعديل",
      "BLOCKED": "توقف",
      "APPROVERS_REFRESHED": "حُدّث المعتمدون",
      "REASSIGNED": "أُعيد الإسناد",
      "REMINDER_DUE": "أُرسل تذكير",
      "OVERDUE": "تأخر",
      "APPROVED": "اعتُمد بالكامل",
      "ACTION_QUEUED": "أُدرج الإجراء بعد الاعتماد",
      "ACTION_SUCCEEDED": "اكتمل الإجراء بعد الاعتماد",
      "ACTION_FAILED": "فشل الإجراء بعد الاعتماد",
      "ACTION_RETRIED": "أُعيدت محاولة الإجراء بعد الاعتماد",
      "DOCUMENT_ACTED": "اكتمل المستند",
      "CANCELLED": "أُلغي",
      "SUPERSEDED": "استُبدل"
    },
    "delegations": {
      "title": "تفويضات الاعتماد",
      "intro": "كل التفويضات في الشركة: من يبتّ نيابةً عن من، ومتى.",
      "new": "تفويض جديد",
      "table": "التفويضات",
      "from": "من",
      "to": "إلى",
      "createdBy": "أنشأه",
      "userFilter": "الشخص",
      "allUsers": "الجميع",
      "views": {
        "label": "عروض التفويضات",
        "all": "الكل",
        "current": "نافذة",
        "upcoming": "قادمة",
        "past": "منتهية"
      },
      "empty": "لا توجد تفويضات",
      "emptyBody": "تظهر هنا التفويضات التي ينشئها الموظفون أو تنشئها أنت نيابةً عنهم.",
      "rowActions": "إجراءات التفويض من {{from}} إلى {{to}}",
      "revokeBody": "لن يتمكن {{to}} من البت في موافقات {{from}} بعد الآن. القرارات السابقة تبقى كما هي."
    },
    "failure": {
      "PERIOD_LOCKED": "تاريخ المشتريات يقع في فترة مقفلة أو قبلها، فرفضت الدفاتر الترحيل. غيّر تاريخ الإقفال أو تاريخ المشتريات.",
      "SUPPLIER_INACTIVE": "المورد غير نشط أو مؤرشف، فلا يمكن ترحيل المشتريات. أعد تفعيل المورد.",
      "APPROVAL_STALE": "تغيّرت المشتريات بعد اعتمادها فلم تُرحَّل، ويجب تقديمها للاعتماد مرة أخرى.",
      "DATA_RULE": "تخالف المشتريات قاعدة في الدفاتر (مثل حساب غير محدد) فلم تُرحَّل. صحّح المشتريات.",
      "other": "رُفض الترحيل. راجع المشتريات ثم أعد المحاولة.",
      "lockDate": "فتح إعداد تاريخ الإقفال",
      "lockDateAsk": "اطلب من المسؤول عن تاريخ الإقفال (الإعدادات › تاريخ الإقفال) أن يغيّره.",
      "lockDateOff": "المحاسبة معطّلة لشركتك، فلا يستطيع أحد هنا تغيير تاريخ الإقفال. اطلب ذلك من مزوّد الخدمة، أو غيّر تاريخ المشتريات."
    },
    "stepBlocked": "متوقفة"
  },
  "label": "{{type}} · {{label}}",
  "resolution": {
    "via": "حُدِّد بصفته {{how}}",
    "fallback": "من الدور البديل: لم يستطع {{who}} الاعتماد",
    "levelUp": " (المستوى +{{n}})",
    "assignee": {
      "HEAD_OF": {
        "subject": "رئيس وحدة المستند",
        "requester": "رئيس وحدة مقدم الطلب"
      },
      "HRBP_OF": {
        "subject": "شريك الموارد البشرية لوحدة المستند",
        "requester": "شريك الموارد البشرية لوحدة مقدم الطلب"
      }
    },
    "walksTitle": "من تم تجاوزه أثناء الصعود",
    "walksLabel": "كيف حُدِّد المعتمِد",
    "unknownUnit": "وحدة غير معروفة",
    "reason": {
      "VACANT": "لا يوجد رئيس",
      "NO_UNIT": "الوحدة غير معروفة",
      "FALLBACK": "لم يستطع أي رئيس الاعتماد: يقرر الدور البديل",
      "VACANT_HRBP": "لا يوجد شريك موارد بشرية",
      "FALLBACK_HRBP": "لم يستطع أي شريك موارد بشرية الاعتماد: يقرر الدور البديل",
      "REQUESTER": "قدّم الطلب",
      "USER_INACTIVE": "مستخدم غير نشط",
      "MISSING_PERMISSION": "لا يملك صلاحية الاعتماد",
      "PRIOR_APPROVER": "اعتمد خطوة سابقة",
      "NOT_ASSIGNED": "غير مكلّف بهذه الخطوة",
      "SUBJECT_MODULE_OFF": "وحدة المستند متوقفة"
    }
  }
}
